module.exports = __webpack_public_path__ + "img/gps.13b418aa.png";